export enum RoleAvailableFor
{
    employee = 1 ,
    clientContact = 2,
    vendor = 3
}
